/**
 * Built-in agent tools for agentic workflows.
 * Definitions only—no live connections yet (web search, file search, code, etc.).
 */

import type { AgentToolDef } from "@/types/agentWorkflow";

export const AGENT_TOOL_DEFS: AgentToolDef[] = [
  {
    id: "web_search",
    name: "web_search",
    description:
      "Search the web for up-to-date information. Use when the user asks about current events, facts, or anything that may have changed.",
    inputSchema: {
      type: "object",
      properties: {
        query: { type: "string", description: "Search query" },
      },
      required: ["query"],
    },
  },
  {
    id: "file_search",
    name: "file_search",
    description:
      "Search the user's connected files and knowledge base for relevant content.",
    inputSchema: {
      type: "object",
      properties: {
        query: { type: "string", description: "Search query" },
      },
      required: ["query"],
    },
  },
  {
    id: "code_interpreter",
    name: "code_interpreter",
    description:
      "Run Python code to compute, analyze data, or generate outputs. Use for math, data, or when the user asks to generate or compute something.",
    inputSchema: {
      type: "object",
      properties: {
        code: { type: "string", description: "Python code to run" },
      },
      required: ["code"],
    },
  },
  {
    id: "image_generation",
    name: "image_generation",
    description:
      "Generate an image from a natural language description. Use when the user asks to create, draw, or generate an image.",
    inputSchema: {
      type: "object",
      properties: {
        prompt: { type: "string", description: "Image description" },
      },
      required: ["prompt"],
    },
  },
  {
    id: "connector_shopify",
    name: "connector_shopify",
    description:
      "Access Shopify store data (orders, products). Use when the user mentions orders, store, or Shopify. Not connected yet—returns placeholder.",
    inputSchema: {
      type: "object",
      properties: {
        action: {
          type: "string",
          enum: ["list_orders", "get_order", "list_products"],
          description: "Action to perform",
        },
        limit: { type: "number", description: "Max items (optional)" },
      },
      required: ["action"],
    },
  },
];

export function getAgentToolDef(id: string): AgentToolDef | undefined {
  return AGENT_TOOL_DEFS.find((t) => t.id === id);
}

export function getAgentToolsByIds(ids: string[]): AgentToolDef[] {
  return ids
    .map((id) => getAgentToolDef(id))
    .filter((t): t is AgentToolDef => !!t);
}
